import {
    MenuItemProps,
} from "@bsm/component";
import { useLeftSideBarMenuGeneral } from "./useLeftSideBarMenuGeneral";
import { useLeftSideBarMenuAdminManagement } from "./useLeftSideBarMenuAdminManagement";
import { useLeftSideBarMenuParameters } from "./useLeftSideBarMenuParameters";

export const useLeftSideBarMenu = (): Array<MenuItemProps> => {

    const generalMenu = useLeftSideBarMenuGeneral()
    const adminManagementMenu = useLeftSideBarMenuAdminManagement()
    const parametersMenu = useLeftSideBarMenuParameters()

    return [
        generalMenu,
        adminManagementMenu,
        parametersMenu
    ];
};

